import { Typography } from '@mui/material'
import React from 'react'
import { PropsTextFunction } from '../../../styles'

export const Title = (props) => {
  return (
    <Typography
        variant="h4"
        component="h1"
        sx={ PropsTextFunction(props) }
    >
        { props?.text }
    </Typography>
  )
}
